import { render, staticRenderFns } from "./CreateAdyenPlatformAccount.vue?vue&type=template&id=74bf9507"
import script from "./CreateAdyenPlatformAccount.vue?vue&type=script&lang=js"
export * from "./CreateAdyenPlatformAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports